import React from 'react'
import { Indicator } from '@CommonComponents'
import { history } from '../App'
import { useStateValue } from '@State'

export const ConfigBase = props => {
  let [, dispatch] = useStateValue()
  const resetSelectState = async () => {
    await dispatch({
      type: 'assessmentInclusion',
      payload: [],
    })
    await dispatch({
      type: 'sectionSelection',
      selectedSections: [],
    })
    await dispatch({
      type: 'linksPosting',
      linksPosting: false,
    })
    await dispatch({
      type: 'linksPosted',
      linksPosted: false,
    })
    history.goBack()
  }
  return (
    <React.Fragment>
      <a
        className="text-dec-none mb-5"
        style={{ fontSize: '1.4em' }}
        onClick={resetSelectState}
      >
        <div className="far fa-long-arrow-left" /> Back
      </a>
      <h4 className="mb-0 mt-5">{props.courseTitle}</h4>
      <h2 className="mt-0">Configure {props.pageTitle} Links</h2>
      <div className="row mt-5">
        <div className="col-lg-13 mr-5 ">
          <Indicator display top="0.4em" /> {props.pageTitle} link exists in
          Canvas
          <div className="mt-5 d-flex justify-content-between">
            <React.Fragment>
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  disabled={
                    props.allItems == 0 ||
                    props.itemsPosting ||
                    props.itemsPosted
                  }
                  checked={props.checkFunc(...props.funcParams)}
                  onChange={() =>
                    props.selFunc(...props.funcParams, props.dispatch)
                  }
                />
                <span
                  className={`${
                    props.allItems == 0 && 'text-muted'
                  } ml-2 font-weight-bold`}
                >
                  Select All
                </span>
              </div>
            </React.Fragment>
            <div>
              <a
                className="text-dec-none"
                onClick={() =>
                  props.dispatch({ type: props.expandFuncType, payload: [] })
                }
              >
                Collapse All
              </a>
              <a
                className="text-dec-none ml-5"
                onClick={() => props.expandFunc(...props.expandFuncParams)}
              >
                Expand All
              </a>
            </div>
          </div>
          {props.leftSide()}
        </div>
        <div className="col-lg-10">{props.rightSide()}</div>
      </div>
    </React.Fragment>
  )
}
